var _circle, _circle2, _circle3, _circle4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotVerified = function SvgNotVerified(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "#ff94a4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "url(#a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    stroke: "#fff",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 120,
    height: 120,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "#6b0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a2b35",
    stroke: "#6a2b35",
    strokeWidth: 4,
    d: "M96 69.1426c0 12.3929-6.5535 23.8624-17.2305 30.1543l-10.2314 6.0281c-1.5664.923-3.5098.923-5.0762 0l-10.2314-6.0281C42.5535 93.005 36 81.5355 36 69.1426V42.4912l1.4502-.4141 5.5068-1.5732c5.4873-1.5678 10.7658-3.7916 15.7207-6.623l6.3301-3.6172.9922-.5674.9922.5674 6.3301 3.6172c4.9549 2.8314 10.2334 5.0552 15.7207 6.623l5.5068 1.5732L96 42.4912z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34 40 5.5062-1.5732c5.642-1.612 11.069-3.8983 16.1635-6.8095L62 28l6.3303 3.6173c5.0945 2.9112 10.5215 5.1975 16.1635 6.8095L90 40v25.1429c0 11.6848-6.1792 22.4984-16.2462 28.4307l-10.2307 6.0289c-.9399.5535-2.1063.5535-3.0462 0l-10.2307-6.0289C40.1792 87.6413 34 76.8277 34 65.1429z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fa5067",
    strokeWidth: 4,
    d: "M92 65.1426c0 12.3929-6.5535 23.8624-17.2305 30.1543l-10.2314 6.0281c-1.5664.923-3.5098.923-5.0762 0l-10.2314-6.0281C38.5535 89.005 32 77.5355 32 65.1426V38.4912l1.4502-.4141 5.5068-1.5732c5.4873-1.5678 10.7658-3.7916 15.7207-6.623l6.3301-3.6172.9922-.5674.9922.5674 6.3301 3.6172c4.9549 2.8314 10.2334 5.0552 15.7207 6.623l5.5068 1.5732L92 38.4912z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9e001b",
    d: "m98 41-4-4v4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa5067",
    d: "M58 46h8v24h-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 77,
    r: 4,
    fill: "#fa5067"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 124,
    y1: 4,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104167,
    stopColor: "#ff2f00",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 68,
    height: 84.6248,
    x: 30,
    y: 23.393,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.529412 0 0 0 0 0.203922 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2059_7068"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.529412 0 0 0 0 0.203922 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2059_7068",
    result: "effect2_dropShadow_2059_7068"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.529412 0 0 0 0 0.203922 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_2059_7068",
    result: "effect3_dropShadow_2059_7068"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.529412 0 0 0 0 0.203922 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_2059_7068",
    result: "effect4_dropShadow_2059_7068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_2059_7068",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "not-verified.3cb33a02dcca388c94b306d8871a727b.svg";